<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងភាពយន្ត</h4>
		</div>
		<div class="md-layout-item md-medium-size-50 md-size-50 text-right">
			<md-button class="md-raised md-primary" @click="$router.push('/films/new')">បង្កើតភាពយន្តថ្មី</md-button>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-15">
								<md-field>
									<label>ស្វែងរកភាពយន្តតាមរយៈឈ្មោះ</label>
									<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<md-field>
									<label>ស្ថានភាព</label>
									<md-select placeholder="ស្ថានភាព" v-model="search.status">
										<md-option value="">ទាំងអស់</md-option>
										<md-option value="0">មិនដំណើរការ</md-option>
										<md-option value="1">ដំណើរការ</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<md-field>
									<label>ការបង្ហាញរឿង</label>
									<md-select placeholder="ការបង្ហាញរឿង" v-model="search.visibility">
										<md-option value="">ទាំងអស់</md-option>
										<md-option value="all">បង្ហាញទាំងអស់</md-option>
										<md-option value="web">បង្ហាញតែ WEB</md-option>
										<md-option value="mobile">បង្ហាញតែ APP</md-option>
										<md-option value="none">មិនបង្ហាញ</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<md-field>
									<label>ប្រភេទរឿង</label>
									<md-select placeholder="ប្រភេទរឿង" v-model="search.type">
										<md-option value="">ទាំងអស់</md-option>
										<md-option value="movie">ភាពយន្ត</md-option>
										<md-option value="series">រឿងភាគ</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<md-field>
									<label>បណ្តុំរឿង</label>
									<md-select placeholder="បណ្តុំរឿង" v-model="search.category_id">
										<md-option value="">ទាំងអស់</md-option>
										<md-option v-for="i in categoryList" :value="i.id">{{i.name.replace("||", ", ")}}</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-15">
								<md-field>
									<label>ប្រភេទជាវ</label>
									<md-select placeholder="ប្រភេទជាវ" v-model="search.subscription">
										<md-option value="">ទាំងអស់</md-option>
										<md-option value="rent">ជួល</md-option>
										<md-option value="member">សមាជិក</md-option>
										<md-option value="free">ឥតគិតថ្លៃ</md-option>
									</md-select>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-50 md-size-10">
								<md-button class="md-raised md-primary" @click="searchHandler()"
									style="width: 100%">{{translate(locale.search)}}</md-button>
							</div>
						</div>
						<md-table v-if="filmList.length > 0">
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>រូបភាព</md-table-head>
								<md-table-head>ចំណងជើង</md-table-head>
								<md-table-head>ព័ត៌មានរឿង</md-table-head>
								<md-table-head>ប្រភេទ និងការបង្ហាញ</md-table-head>
								<md-table-head>តម្លៃជួល</md-table-head>
								<md-table-head v-if="allow_user('super-admin|operation-admin')">ចំណូលសរុប</md-table-head>
								<md-table-head>ដៃគូសហការ</md-table-head>
								<md-table-head>ប្រភេទជាវ</md-table-head>
								<md-table-head>ស្ថានភាពបម្លែង</md-table-head>
								<md-table-head>ស្ថានភាព</md-table-head>
								<md-table-head>សកម្មភាព</md-table-head>
							</md-table-row>

							<md-table-row v-for="(film, index) in filmList">
								<!-- <md-table-cell></md-table-cell> -->
								<md-table-cell>​{{ index + 1 }}</md-table-cell>
								<md-table-cell><img :src="config.cdn + 'images/' + film.poster_url" class="poster"><img :src="config.cdn + 'images/' + film.cover_url" class="cover"></md-table-cell>
								<md-table-cell><b>{{film.title}}</b><br>{{config.datelify(film.created_date)[1]}}<br>អ្នកមើល {{film.total_view + film.total_all_view}}</md-table-cell>
								<md-table-cell><b>{{config.getLanguage(film.language)}}</b><br>{{config.getDuration(film.duration)}}<br>{{film.year}}, {{config.getQuality(film.quality)}}</md-table-cell>
								<md-table-cell><b>{{config.getType(film.type)}}</b><br>{{config.getPlatform(film.visibility)}}</md-table-cell>
								<md-table-cell><b>{{config.moneylify(film.rental_price)}}</b></md-table-cell>
								<md-table-cell v-if="allow_user('super-admin|operation-admin')"><b>{{config.moneylify(film.total_income)}}</b></md-table-cell>
								<md-table-cell><b>{{film.partner_name}}</b><br>{{film.dividend}}%</md-table-cell>
								<md-table-cell><span class="green">{{config.getSubscription(film.subscription)}}</span></md-table-cell>
								<md-table-cell>
									<template v-if="film.type == 'movie'">
										<span class="red" v-if="film.server_processing_status == 0">{{config.getProcessStatus(film.server_processing_status)}}</span>
										<span class="green" v-if="film.server_processing_status == 1">{{config.getProcessStatus(film.server_processing_status)}}</span>
										<span class="yellow" v-if="film.server_processing_status == 2">{{config.getProcessStatus(film.server_processing_status)}}</span>
										<span class="gray" v-if="film.server_processing_status == 3">{{config.getProcessStatus(film.server_processing_status)}}</span>
										<span class="red" v-if="film.server_processing_status == 4">{{config.getProcessStatus(film.server_processing_status)}}</span>
									</template>
									<template v-else>
										<span class="green">មើលខាងក្នុង</span>
									</template>

								</md-table-cell>
								<md-table-cell>
									<span class="green" v-if="film.status == 1">{{config.getStatus(film.status)}}</span>
									<span class="red" v-if="film.status == 0">{{config.getStatus(film.status)}}</span>
								</md-table-cell>
								
								<md-table-cell>
									<router-link :to="'films/detail/' + film.hash">
										<md-button class="md-just-icon md-simple md-primary">
											<md-icon>visibility</md-icon>
											<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
										</md-button>
									</router-link>
									<router-link :to="'films/edit/' + film.hash">
										<md-button class="md-just-icon md-simple md-primary">
											<md-icon>edit</md-icon>
											<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
										</md-button>
									</router-link>
									<md-button class="md-just-icon md-simple md-danger" @click="onDelete(film.hash)">
										<md-icon>delete</md-icon>
										<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
						<h5 class="text-center" v-if="filmList.length == 0 && loaded == true">មិនមានភាពយន្ត</h5>
						<div class="text-right" v-if="loadMore">
							<md-button class="md-primary" @click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
						</div>
					</div>

					<md-dialog-confirm :md-active.sync="deleteDialogActive"
						:md-title="'លុបភាពយន្តចេញ ?'"
						:md-cancel-text="translate(locale.cancel)" @md-cancel="onCancel" @md-confirm="onDelete" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getCategory();
			this.searchHandler();
		},

		data() {
			return {
				loaded: false,
				deleteDialogActive: false, deleteSelected: '',
				search: { text: "", status: "", type: "", category_id: "", subscription: "", visibility: "" },
				loadMore: false,
				categoryList: [],
				filmList: []
			}
		},
		methods: {
			getCategory(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/film_category/search", { text: "", size: size, offset: 0 }).then(data => {
					this.categoryList = data.body.data;
				})
			},
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/film/search", {
					text: this.search.text,
					status: this.search.status,
					type: this.search.type,
					category_id: this.search.category_id,
					subscription: this.search.subscription,
					visibility: this.search.visibility,
					size: size,
					offset: more ? this.filmList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.filmList = more ? this.filmList.concat(data.body.data) : data.body.data;
				})
			},
			onDelete(hash) {

				if (this.deleteSelected == "") {
					this.deleteDialogActive = true;
					this.deleteSelected = hash;
					return;
				}

				this.$http.post(this.config.api + "/user/film/delete", {
					hash: this.deleteSelected
				}).then(res => {
					this.onCancel();
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកបានលុបភាពយន្តនេះដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
					}
				})
			},

			onEnable(hash) {

				this.$http.post(this.config.api + "/admin/client/enable", {
					hash: hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have enabled the system client successfully.||អ្នកបានដាក់ដំណើរការប្រព័ន្ធនេះដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.poster {
		height: 70px;
		width: auto;
	}
	.cover {
		height: 70px;
		width: auto;
		margin-left: 10px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Films/View.vue